// extracted by mini-css-extract-plugin
export default {"resizer":"Resizer_resizer__QziIo","isResizing":"Resizer_isResizing__CJKRT"};